/**
 * Carousel Slider
 * 
 * 
 */
import gsap from 'gsap';

export default class CarouselSlider {
    private carousel: HTMLElement;
    private slides: NodeListOf<Element>;
    private loop: number;
    private next: HTMLElement;
    private prev: HTMLElement;
    private bullets: Array<Element>;
    private currentSlide: number = 0;

    constructor(carousel: HTMLElement) {
        if(!carousel) return;
        this.carousel = carousel;
        this.slides = this.carousel.querySelectorAll('.carousel-slide');
        if (this.slides) {
            this.setupNav();
            this.setupBullets();
            this.slideTo(2);
        }
    }

    setupNav(){
        this.next = this.carousel.querySelector('.carousel-next');
        if(this.next){
            this.next.addEventListener('click', () => {
                this.currentSlide = (this.currentSlide+1 < this.slides.length) ? this.currentSlide+1 : 0; 
                this.slideTo(this.currentSlide);
            });
        }
        this.prev = this.carousel.querySelector('.carousel-prev');
        if(this.prev){
            this.prev.addEventListener('click', () => {
                this.currentSlide = (this.currentSlide === 0) ? this.slides.length-1 : this.currentSlide-1; 
                this.slideTo(this.currentSlide)
            });
        }
    }

    setupBullets(){
        const numberOfSlides = this.slides.length;
        const nav = document.createElement('div');
        nav.classList.add('carousel-slide-nav');
        const bullets = [];
        for(let i = 0; i < numberOfSlides; i++){
            bullets[i] = document.createElement('span');
            bullets[i].innerText = (i+1).toString();
            if(i === 0) bullets[i].classList.add('carousel-slide-bullet-active');
            bullets[i].addEventListener('click', () => {
                this.slideTo(i);
            });
            this.bullets = bullets;
            nav.appendChild(bullets[i]);
        }
        this.carousel.querySelector('.carousel-slides-wrap').appendChild(nav);
    }

    slideTo(slideIndex){
        window.clearTimeout(this.loop);
        const currentSlide = this.carousel.querySelector('.carousel-slide-active');
        currentSlide.classList.remove('carousel-slide-active');
        const currentBullet = this.carousel.querySelector('.carousel-slide-bullet-active');
        currentBullet.classList.remove('carousel-slide-bullet-active');
        this.bullets[slideIndex].classList.add('carousel-slide-bullet-active');
        this.slides[slideIndex].classList.add('carousel-slide-active');
        // this.start();
    }

    start() {
        this.loop = window.setTimeout(() => {
            this.currentSlide = (this.currentSlide == this.slides.length-1) ? 0 : this.currentSlide+1 ;
            this.slideTo(this.currentSlide);
        }, 10000);
    };
}